<template>
  <Layout>
    <div class="row">
      <div class="col-6">
        <PageHeader class="col-11" title="NMS Account Management" />
      </div>
      <div class="col-6">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showCreateNmsModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i> Add NMS Account
          </button>
        </div>
      </div>
    </div>

    <!-- Devices Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="nmsAccounts"
        :fields="fields"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(role_name)="row">
          <span>{{ String(row.item.role_name).toUpperCase() }}</span>
        </template>

        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toLocaleDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(updated_at)="row">
          <span
            >{{ new Date(row.item.updated_at).toLocaleDateString() }}
            {{ new Date(row.item.updated_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(is_active)="row">
          <span :class="`badge ${getStatusClass(row.item.is_active)}`">{{
            row.item.is_active ? "Active" : "Disabled"
          }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="success"
            class="m-1"
            @click="testConnection(row.item)"
          >
            Test
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="editNmsAccount(row.item)"
          >
            Edit
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            @click="deleteNmsAccount(row.item.id)"
          >
            Delete
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Create new device modal -->
    <b-modal
      id="create-new-nms-modal"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>New NMS Account</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('create-new-nms-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createAndUpdateNms">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>NMS Name</label>
              <input
                placeholder="Enter Friendly Name"
                v-model="createNewNmsInstance.name"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>NMS URL</label>
              <input
                placeholder="Ex: https://nms.sugoiindo.in/"
                v-model="createNewNmsInstance.url"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Username</label>
              <input
                placeholder="Enter Login Username"
                v-model="createNewNmsInstance.username"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Password</label>
              <input
                placeholder="Enter Login Password"
                v-model="createNewNmsInstance.password"
                type="password"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-6">
            <div class="mt-2">
              <button
                type="button"
                @click="testConnection(createNewNmsInstance)"
                href="javascript:void()"
                class="btn btn-info me-1 w-100"
                :disabled="!isTestConnectionEnabled"
              >
                Test Connection <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
          <div class="col-6">
            <div class="mt-2">
              <button type="submit" class="btn btn-success me-1 w-100">
                Save NMS <i class="bx bx-save ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import adminMixin from "@/mixins/administration";
import Swal from "sweetalert2";

export default {
  page: {
    title: "NMS Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      createNewNmsInstance: {},
      nmsAccounts: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "name",
          label: "Account Name",
          sortable: false,
        },
        {
          key: "url",
          label: "URL",
          sortable: false,
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
        },
        {
          key: "password",
          label: "Password",
          sortable: false,
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: false,
        },
        {
          key: "updated_at",
          label: "Updated At",
          sortable: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [adminMixin],
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    this.nmsAccounts = await this.GetNMSAccounts();
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
  computed: {
    isTestConnectionEnabled() {
      return this.createNewNmsInstance &&
        this.createNewNmsInstance.url &&
        this.createNewNmsInstance.username &&
        this.createNewNmsInstance.password
        ? true
        : false;
    },
  },
  methods: {
    showCreateNmsModal() {
      this.$bvModal.show("create-new-nms-modal");
    },

    async createAndUpdateNms() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.SaveNMSAccount(this.createNewNmsInstance);
        this.createNewNmsInstance = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Success", "NMS Account Saved", "success").then(() => {
          this.$bvModal.hide("create-new-nms-modal");
        });

        this.nmsAccounts = await this.GetNMSAccounts();
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "warning");
      }
    },

    async deleteNmsAccount(id) {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the nms account?",
          icon: "warning",
          showDenyButton: true,
          showConfirmButton: true,
          denyButtonText: "Cancel",
          confirmButtonText: "Yes",
        }).then(async (val) => {
          if (val.isConfirmed) {
            this.$store.dispatch("layout/changeLoaderValue", true);
            await this.DeleteNMSAccount({ id: id });
            this.createNewNmsInstance = {};
            this.$store.dispatch("layout/changeLoaderValue", false);
            Swal.fire("Success", "NMS Account Deleted", "success").then(() => {
              this.$bvModal.hide("create-new-nms-modal");
            });

            this.nmsAccounts = await this.GetNMSAccounts();
          }
        });
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    async testConnection(data) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.VerifyZabbixConnection({
          zabbixUrl: data.url,
          username: data.username,
          password: data.password,
        });

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Success", "Connection Successful", "success");
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    editNmsAccount(data) {
      this.createNewNmsInstance = data;
      this.$bvModal.show("create-new-nms-modal");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
